import { render, staticRenderFns } from "./overflowTxt.vue?vue&type=template&id=4e364cc6&scoped=true"
import script from "./overflowTxt.vue?vue&type=script&lang=js"
export * from "./overflowTxt.vue?vue&type=script&lang=js"
import style0 from "./overflowTxt.vue?vue&type=style&index=0&id=4e364cc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e364cc6",
  null
  
)

export default component.exports